module.exports = "/next-static/_next/static/images/hero_image_large-a1ff364dd5b703186d675a889ab187de.png";